import axios from '@/axios.js';

export const newsletterApi = {
  getNewsletters(payload) {
    return axios.get('admin/newsletters', {
      params: payload,
    });
  },
  getNewsletter(id) {
    return axios.get(`admin/newsletters/${id}?join=translations`);
  },
  addNewsletter(body) {
    return axios.post('admin/newsletters', body);
  },
  updateNewsletter(id, body) {
    return axios.patch(`admin/newsletters/${id}`, body);
  },
  deleteNewsletter(id) {
    return axios.delete(`admin/newsletters/${id}`);
  },
};
